var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as pdfjs from 'pdfjs-dist/build/pdf';
import * as pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry';
import { ViewportSizeDefault } from '../enums';
const getUint8Array = (file) => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield file.arrayBuffer();
    return new Uint8Array(data);
});
const getPdfPage = (uint8array, pageCount) => __awaiter(void 0, void 0, void 0, function* () {
    const pdf = yield pdfjs.getDocument(uint8array).promise;
    return pdf.getPage(pageCount);
});
const setupCanvas = (viewPort, canvas) => {
    canvas.height = viewPort.height || ViewportSizeDefault.VIEWPORT_HEIGHT;
    canvas.width = viewPort.width || ViewportSizeDefault.VIEWPORT_WIDTH;
    return canvas;
};
export const convertPdfToImages = (file, pageCount = 1, scaleViewPort = 1) => __awaiter(void 0, void 0, void 0, function* () {
    let canvas = document.createElement('canvas');
    let context;
    pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;
    const uintArray = yield getUint8Array(file);
    const page = yield getPdfPage(uintArray, pageCount);
    const viewport = page.getViewport({ scale: scaleViewPort });
    context = canvas.getContext('2d');
    canvas = setupCanvas(viewport, canvas);
    yield page.render({ canvasContext: context, viewport: viewport }).promise;
    const imageUrl = canvas.toDataURL();
    canvas.remove();
    return imageUrl;
});
//# sourceMappingURL=PdfToImageConversion.js.map